import { render, staticRenderFns } from "./GameSession.vue?vue&type=template&id=057764a5&scoped=true&"
import script from "./GameSession.vue?vue&type=script&lang=js&"
export * from "./GameSession.vue?vue&type=script&lang=js&"
import style0 from "./GameSession.vue?vue&type=style&index=0&id=057764a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057764a5",
  null
  
)

export default component.exports